import { render, staticRenderFns } from "./Background.vue?vue&type=template&id=50c54c62&scoped=true"
import script from "./Background.vue?vue&type=script&lang=js"
export * from "./Background.vue?vue&type=script&lang=js"
import style0 from "./Background.vue?vue&type=style&index=0&id=50c54c62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c54c62",
  null
  
)

export default component.exports